// Paletas precargadas de "Atelier" (segunda boda).
const FUENTES = {
  display: '"Marcellus", Georgia, serif',
  cuerpo: '"Jost", system-ui, sans-serif',
};

export const paletas = [
  {
    clave: "perla",
    nombre: "Perla",
    tema: {
      colores: {
        fondo: "#FBFAF7",
        fondoAlt: "#F4F1EA",
        texto: "#22211F",
        textoSuave: "#57534C",
        textoTenue: "#8F8A80",
        primario: "#3E3A34",
        primarioSuave: "#EBE7DE",
        acento: "#B08D6A",
        borde: "rgba(62, 58, 52, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "oliva",
    nombre: "Oliva",
    tema: {
      colores: {
        fondo: "#F6F7F2",
        fondoAlt: "#EDEFE4",
        texto: "#25271F",
        textoSuave: "#535744",
        textoTenue: "#8A8E7A",
        primario: "#5A6242",
        primarioSuave: "#E6E9D8",
        acento: "#A99356",
        borde: "rgba(90, 98, 66, 0.18)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "ciruela",
    nombre: "Ciruela",
    tema: {
      colores: {
        fondo: "#FAF6F8",
        fondoAlt: "#F3EBEF",
        texto: "#2C2028",
        textoSuave: "#5F4B56",
        textoTenue: "#97848E",
        primario: "#6E3B52",
        primarioSuave: "#EFDEE6",
        acento: "#B8925A",
        borde: "rgba(110, 59, 82, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
];
